import React, { useState, useEffect } from 'react'
import { useSlate, ReactEditor } from 'slate-react'
import { Transforms, Editor } from 'slate'
import { isMarkActive, getNode } from '@udecode/slate-plugins'
import { SketchPicker } from 'react-color';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import clsx from 'clsx'
import styled from 'styled-components'

import { MARK_BACKGROUND_COLOR } from '../Canvas/TratoFormat/Marks'



const CurrentColor = styled.div`
  width: 1.25em;
  height: 3px;
  borderRadius: 2px;
  background: ${props => props.color}
`

export function ToolbarColorPicker({ currentColor, icon,  isDisabled, onClick, onColorChange }) {
  return (
    <UncontrolledDropdown tag="span" className="align-self-center" contentEditable={false} disabled={isDisabled}>
      <DropdownToggle className="px-0" color="light" disabled={isDisabled}>
        <div className="d-flex justify-content-center align-items-center" onMouseDown={onClick}>
            <div>
              <i className={`fas fa-${icon} fa-fw text-muted`} />
              <CurrentColor color={currentColor} />
            </div>
            <div>
              <i className="fas fa-angle-down fa-fw text-muted"  />
            </div>
        </div>
      </DropdownToggle>
      <DropdownMenu >
        <SketchPicker className="mt-n2" color={currentColor} onChange={onColorChange} disableAlpha={true} />
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default function BackgroundColorButton({ isDisabled }) {
  const [currentColor, setCurrentColor] = useState('#000')
  const [mark, setMark] = useState(null);
  const editor = useSlate()
  const { selection } = editor;

  useEffect(() => {
   try {
      const marks = Editor.marks(editor);
      if (marks) {
        const fontColor = marks?.[MARK_BACKGROUND_COLOR] ? marks[MARK_BACKGROUND_COLOR] : '#000'
      
        setCurrentColor(fontColor)
      }
    } catch {
      setCurrentColor('#000')
    }
  }, [editor, selection])

  const handleClick = (evt) => {
    evt.preventDefault();
    const { selection } = editor;

    setMark(selection);
  };


  const handleChange = (color, e) => {
    try {
      e.preventDefault()
      e.stopPropagation();
      const { selection } = editor;

      console.log({ mark })
     
      if (selection) {
        // ReactEditor.focus(editor);
        // Transforms.select(editor, mark);
        if (color.hex === '#000000') {
          editor.removeMark(MARK_BACKGROUND_COLOR);
        } else {
          editor.addMark(MARK_BACKGROUND_COLOR, color.hex);
        }
      } else {
        
        // updateAllTextNodes(editor, { [MARK_BACKGROUND_COLOR]: value }, {
        //   specialTextNodes: true
        // });        
      }

      setCurrentColor(color.hex)
    } catch (error) {
      console.error('BackgroundColorError', error)
    }
  };

  return (
    <ToolbarColorPicker 
      icon="highlighter"
      currentColor={currentColor}
      onClick={handleClick}
      onColorChange={handleChange}
      isDisabled={isDisabled}
    />
  )
}
